<template>
  <div class="recruitment-container">
    <div class="recruitment-top">
      <carousel :list="bannerList"/>
    </div>
    <div class="recruitment-main">
      <!--人才体系-->
      <talent/>
      <!--招聘信息-->
      <hire />
    </div>
  </div>
</template>

<script setup>
import {ref} from "vue";
import carousel from '@/components/carousel/index.vue'
import {getBannerList} from "@/api/apiHome";
import talent from './components/talent.vue'
import hire from './components/hire.vue'
const bannerList = ref([])
const queryBannerList = async () => {
  const {code, data} = await getBannerList(8)
  if (code === 200) {
    bannerList.value = data
  }
}
queryBannerList()
</script>

<style lang="scss" scoped>

.recruitment-top {
  width: 100%;
  height: 450px;
  overflow: hidden;
}

.recruitment-main {
  width: 1200px;
  margin: 0 auto;
  position: relative;
  padding-left: 20px;
  padding-right: 20px;
  box-sizing: border-box;
}

</style>
